import { render, staticRenderFns } from "./MedicineRecall.vue?vue&type=template&id=172c8c2a&scoped=true&"
import script from "./MedicineRecall.vue?vue&type=script&lang=js&"
export * from "./MedicineRecall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c8c2a",
  null
  
)

export default component.exports